// @ts-ignore
export function indexTemplateHtml() { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('span', { attrs: { "title": _vm.title }, on: { "mouseenter": function ($event) { _vm.mouseenter(); }, "mouseleave": function ($event) { _vm.mouseleave(); } } }, [_vm._v(_vm._s(_vm.timeText))]); }
// @ts-ignore
export var indexTemplateHtmlStatic = [];
// tslint:enable



//////////////////
// WEBPACK FOOTER
// ./node_modules/relative-time-vue-component/dist/variables.js
// module id = null
// module chunks = 